import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionManagerService } from './core/services/session-manager.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App {
  private readonly sessionManager = inject(SessionManagerService);

  constructor() {
    // Gerenciador ocioso enquanto não houver sessão; permanece ativo para vigilância
    // contínua caso a autenticação ocorra depois (p.ex. callback lento do OAuth).
    this.sessionManager.start();
  }
}
